import { sharedQueryParams } from 'shared-helpers';

export const prepareSelectParam = sharedQueryParams.prepareSelectParam;
export const prepareFilterParam = sharedQueryParams.prepareFilterParam;